<template>
    <div>
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong> removed a trigger.-->
        <span v-html="$t('notification.triggerRemoved', {user:$_.get(activity, 'actorUser.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TriggerRemoved",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
